module.exports = __webpack_public_path__ + "media/images/weather/256_day-5bd31aab1393e44727b01098eb634a12.png";